'use strict';

exports.__esModule = true;
exports.default = Page;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Parser = require('./Parser');

var _Parser2 = _interopRequireDefault(_Parser);

var _getCurrentHref = require('./utils/getCurrentHref');

var _getCurrentHref2 = _interopRequireDefault(_getCurrentHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Page(props) {
  var className = props.className,
      style = props.style,
      _props$href = props.href,
      href = _props$href === undefined ? (0, _getCurrentHref2.default)() : _props$href,
      tabs = props.tabs,
      hideCover = props.hideCover,
      width = props.width,
      height = props.height,
      showFacepile = props.showFacepile,
      hideCTA = props.hideCTA,
      smallHeader = props.smallHeader,
      adaptContainerWidth = props.adaptContainerWidth,
      children = props.children,
      onParse = props.onParse;


  return _react2.default.createElement(
    _Parser2.default,
    { className: className, onParse: onParse },
    _react2.default.createElement(
      'div',
      {
        className: 'fb-page',
        style: style,
        'data-tabs': tabs,
        'data-hide-cover': hideCover,
        'data-show-facepile': showFacepile,
        'data-hide-cta': hideCTA,
        'data-href': href,
        'data-small-header': smallHeader,
        'data-adapt-container-width': adaptContainerWidth,
        'data-height': height,
        'data-width': width
      },
      children
    )
  );
}


Page.defaultProps = {
  width: undefined,
  height: undefined,
  tabs: undefined,
  hideCover: undefined,
  showFacepile: undefined,
  hideCTA: undefined,
  smallHeader: undefined,
  adaptContainerWidth: undefined,
  children: undefined,
  className: undefined,
  onParse: undefined,
  style: undefined,
  href: undefined
};
//# sourceMappingURL=Page.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/Page.js
// module id = 865
// module chunks = 67997519577666